import React from 'react';

const Dashboard = () => {
  
    return (
      <div className="container mx-auto p-4">
        <div className='text-sm w-full flex gap-6'>
              <a href="/education-admin/courses">Courses</a>
              <a href="/education-admin/applications">Applications</a>
        </div>
      </div>
    );
};
  
export default Dashboard;
